var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 18,
    height: 20,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 14,
    height: 4,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5L17 6.5M15 6.5V8.5",
    stroke: "currentColor",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5L7.5 6L8 7.5L8.5 6L9 7.5",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H11V7.5H10V6ZM10 6V5H11V6",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5L6.5 13L8.5 15L11 13.5L9.5 11L8 10.5Z",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "currentColor",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 3,
    height: 2.5,
    rx: 0.5,
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 3,
    height: 2.5,
    rx: 0.5,
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 3,
    height: 2.5,
    rx: 0.5,
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.5H16.5M15.5 20.5H16.5",
    stroke: "currentColor",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.25H16.5M16 10.75V11.75",
    stroke: "currentColor",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.5L16.5 15.5M15.5 15.5L16.5 14.5",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialCalculator);
export default __webpack_public_path__ + "static/media/material-calculator.5e1aeeea90e6c5ceadd1c495416a9af3.svg";
export { ForwardRef as ReactComponent };